export default __webpack_public_path__ + "static/media/983.55608847.gif";